import React from "react";

import { FaRegEyeSlash } from "react-icons/fa";
import { VscLock, VscUnlock } from "react-icons/vsc";
import styled from "styled-components";

import { Button } from "~/components/Button";
import Spacer, { Axis } from "~/components/Spacer";

const LockIconButton = styled(VscLock).attrs(() => ({
  width: "14",
  height: "14",
}))`
  font-size: 14px;
  outline: none;
  cursor: pointer;
`;

const SlashedEyedIconButton = styled(FaRegEyeSlash).attrs(() => ({
  width: "14",
  height: "14",
}))`
  font-size: 14px;
  outline: none;
  cursor: pointer;
`;

const LockIconBanner = styled(VscLock).attrs(() => ({
  width: "22",
  height: "22",
}))`
  font-size: 22px;
  outline: none;
  cursor: pointer;
`;

const UnLockIconBanner = styled(VscUnlock).attrs(() => ({
  width: "22",
  height: "22",
}))`
  font-size: 22px;
  outline: none;
  cursor: pointer;
`;

const Container = styled.section`
  display: flex;
  justify-content: space-between;

  align-items: center;
  padding: 16px;
  gap: 10px;
  background: #ffffff;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
`;

const AnchorNeutral = styled.a`
  color: inherit;
  text-decoration: underline;
  &:hover {
    text-decoration: underline;
  }
`;

export default function DecryptDataSection({
  isEncryptionEnabled,
  onClickButton,
  displayUnverifiedVaspWarning,
}: {
  isEncryptionEnabled: boolean;
  onClickButton: () => void;
  displayUnverifiedVaspWarning?: boolean;
}) {
  return (
    <Container>
      <div>
        {isEncryptionEnabled ? (
          <div style={{ display: "flex" }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <LockIconBanner />
            </div>

            <Spacer axis={Axis.HORIZONTAL} size={18} />
            <div>
              {`Data for this transfer is encrypted. ${
                displayUnverifiedVaspWarning
                  ? "You are not a verified VASP yet, so PII from counterparties cannot be decrypted."
                  : "Click here to decrypt."
              }`}
              {displayUnverifiedVaspWarning && (
                <div>
                  <AnchorNeutral
                    href="https://intercom.help/helpnotabene/en/articles/7845919-how-to-upload-corporate-documents"
                    target="_blank"
                    rel="noopener"
                  >
                    {"Learn how to how to become verified"}
                  </AnchorNeutral>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div style={{ display: "flex" }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <UnLockIconBanner />
            </div>

            <Spacer axis={Axis.HORIZONTAL} size={18} />
            <div>{"Data for this transfer has been decrypted. Click here to conceal."}</div>
          </div>
        )}
      </div>
      {!displayUnverifiedVaspWarning && (
        <Button kind="primary" onClick={onClickButton} disabled={displayUnverifiedVaspWarning}>
          <div style={{ display: "flex", alignItems: "center", height: "36px" }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              {isEncryptionEnabled ? <LockIconButton /> : <SlashedEyedIconButton />}
            </div>
            <Spacer axis={Axis.HORIZONTAL} size={10} />
            <div>{isEncryptionEnabled ? "DECRYPT" : "CONCEAL"}</div>
          </div>
        </Button>
      )}
    </Container>
  );
}
